<template>  
  <v-col cols="12" md="6">
    <div class="overline mt-n3">
      報告写真
    </div>
    <viewer :options="options" :images="photos" class="images clearfix" v-if="photos.length > 0">
      <template v-slot="scope">
        <figure class="images">
          <div
            v-for="{thumb_url, photo_url, id} in scope.images"
            :key="id"
            class="image-wrapper"
            style="border: 1px solid #ddd; border-radius: 5px; position: relative; width: 30%; text-align: center; height: 51px;"
          >
            <div style="position: absolute;top: -10px;right: -10px;z-index:100;"></div>
            <img
              class="image"
              :src="thumb_url"
              :data-source="photo_url"
              :alt="id"
              style="width: 100%; height: 100%; object-fit: contain;"
            >
          </div>
          <br style="clear: both;" />
        </figure>
      </template>
    </viewer>
    <h5 v-else class="subtitle-1">
      写真の登録がありません
    </h5>
  </v-col>
</template>

<script>
import { component as Viewer } from 'v-viewer'
import 'viewerjs/dist/viewer.css'

export default {
  name: 'CustomImageViewer',
  components: {
    Viewer,
  },
  mixins: [],
  props: {
    photos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mdColSize: 4,
      options: {
        url: 'data-source',
        inline: false,
        button: true,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: false,
        zoomable: false,
        rotatable: false,
        fullscreen: true,
      }
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.image-wrapper {
  border: 1px solid #ddd ;
  border-radius: 5px;
  display: inline-block;
  float: left;
  margin-right: 4px;
  padding: 0;
  .image {
    height: 150px;
    cursor: pointer;
    padding: 0;
    border: none;
  }
}
</style>
